import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { EgAssistantBar } from '@expertgroup/assistant';
import { AssistantVisibility } from '@/app/core/auth/assistant-visibility';
import { CopyService } from '@/app/core/copy/copy.service';

@Component({
    selector: 'eg-root',
    imports: [RouterOutlet, ToastModule, EgAssistantBar],
    template: `
        <router-outlet />
        <p-toast position="top-right" />

        <!--
          Panel stoji u KORENU aplikacije, iznad rutera.

          Ranije je bio u ljusci /aplikacija, pa ju je svaki izlazak iz tog podstabla unistavao zajedno sa
          celim stanjem: javna landing ruta, /zabranjen-pristup na koji preusmerava super-admin guard, i 404.
          Pokretac je u gornjoj traci ljuske (main-layout) i nestaje sa njom; panel, razgovor i Ctrl+K ostaju.

          Od 0.12.0 panel je usidren desno, ispod gornje trake, bez maske i bez pomeranja. topOffset se ne
          postavlja: podrazumevanih 60 je visina eg-topbar-a (--s-topbar) u @expertgroup/shell.

          Kontekst ekrana vise ne ide kroz ulaz trake: daje ga resolver nad registrom ekrana
          (provideEgAssistantScreen u app.config.ts), a traka ga preracunava na svakoj navigaciji.

          name je IME asistenta (kljuc assistant.name). Od 0.14.0 traka ga prosledjuje svuda gde se asistent
          imenuje: naslov panela (uz podnaslov "AI asistent" — ime nikad ne tvrdi da je osoba), prazno stanje,
          naslov popovera Objasni i aria-label/title pokretaca. Raniji ulaz label je zastareo alias istog ulaza.
          appName ide u dugme "Nazad u …" preko celog ekrana; ime proizvoda se ne prevodi.
        -->
        @if (assistant.visible()) {
            <eg-assistant-bar [loadContent]="loadAssistant" [name]="t('assistant.name')" appName="ProTax" />
        }
    `
})
export class App {
    /** Isti uslov kao za pokretac u gornjoj traci — vidi `AssistantVisibility`. */
    protected readonly assistant = inject(AssistantVisibility);

    protected readonly t = inject(CopyService).t;

    /**
     * ⚠️ Dinamički `import()`, ne statički uvoz. Statički bi uvukao sadržaj asistenta u početni bundle, a
     * traka je uvek prisutna — time bi „odloženo učitavanje" postojalo samo na papiru.
     *
     * ⚠⚠ Uvozi se ZASEBNA ulazna tačka `@expertgroup/assistant/chat`, ne glavna. Iz glavne tačke lenjosti
     * NEMA: ova aplikacija paket ionako uvozi statički (`provideEgAssistant`, `EgAssistantBar`), pa bi
     * dinamički uvoz istog modula pogodio već učitan modul. Izmereno u radionici: 740 B naspram 13,60 kB.
     */
    protected readonly loadAssistant = () => import('@expertgroup/assistant/chat').then((m) => m.EgAssistantWorkspace);
}
